import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type EnhancedResDocumentOCRResultQuery } from './types'

export const documentOCRResultQuery = (taskId?: number) =>
  queryOptions<EnhancedResDocumentOCRResultQuery, unknown>({
    queryKey: [API_ENDPOINTS.business.v1.ocr.result.index, taskId],
    queryFn: () => w.get(`${API_ENDPOINTS.business.v1.ocr.result.index}/${taskId}`).json(),
    staleTime: Infinity, // NOTE: fetch only once
    enabled: typeof taskId === 'number',
    retry: false,
    select: (response): EnhancedResDocumentOCRResultQuery => {
      const enhancedResponse: EnhancedResDocumentOCRResultQuery = {
        ...response,
        caseNumber: {
          ...response.caseNumber,
          text: response.caseNumber.text || '',
          value: response.caseNumber.value || '',
        },
        caseAdditionalData: !response.caseAdditionalData
          ? {
              caseId: 0, // 0 means there is no case id
              email: '',
              phone: '',
              caseCategory: '',
              caseTags: [],
            }
          : response.caseAdditionalData,
        applicantNameCandidate: {
          ocrScannedApplicantNameWhenNew: response?.applicantName?.value || '',
          ocrScannedApplicantNameWhenExisting: response?.applicantName?.value || '',
          matchingApplicantId: undefined,
        },
      }

      return enhancedResponse
    },
  })
